import React, { Suspense } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Loader from './components/ui/loader';

const Home = React.lazy(() => import('./components/dashboard'));
const Dashboard = React.lazy(() => import('./components/dashboard/dashboard'));
const OverrideReport = React.lazy(() =>
  import('./components/dashboard/override-report')
);
const ECRI = React.lazy(() => import('./components/dashboard/ecri/ecri'));
const Login = React.lazy(() => import('./components/Auth/login'));
const ResetPassword = React.lazy(() =>
  import('./components/Auth/reset-password')
);
const ForgotPassword = React.lazy(() =>
  import('./components/Auth/forgot-password')
);
const Settings = React.lazy(() => import('./components/Settings'));
const Administration = React.lazy(() => import('./components/Administration'));

const Routes = () => (
  <HashRouter>
    <Suspense
      fallback={
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <Loader />
        </div>
      }
    >
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/reset-password" exact component={ResetPassword} />
        <Route path="/forgot-password" exact component={ForgotPassword} />
        <Route path="/settings" exact component={Settings} />
        <Route path="/admin" exact component={Administration} />
        <Route path="/">
          <Home>
            <Switch>
              <Route path="/reports" exact component={OverrideReport} />
              <Route path="/ecri" exact component={ECRI} />
              <Route path="/" exact component={Dashboard} />
            </Switch>
          </Home>
        </Route>
      </Switch>
    </Suspense>
  </HashRouter>
);

export default Routes;
